import { render, staticRenderFns } from "./sabkType.vue?vue&type=template&id=36bfe415&scoped=true"
import script from "./sabkType.vue?vue&type=script&lang=js"
export * from "./sabkType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bfe415",
  null
  
)

export default component.exports